__webpack_require__.p = "/hospitalkiosk/";